import {reactive} from "vue";
const state = reactive({
    isOpen: false,
    resolve: (_val: boolean) => {},
    reject: (_val: boolean) => {},
    content: "",
    title: "",
});

export function useConfirmDialog() {
    function confirm(title: string = "Delete", content: string = "Are You Sure?"): Promise<boolean> {
        state.isOpen = true;
        state.content = content;
        state.title = title;

        return new Promise<boolean>((resolve, reject) => {
            state.resolve = resolve;
            state.reject = reject;
        });
    }

    return {state, confirm};
}
